import { useState, useEffect } from 'react';
import axios from 'axios'; // or fetch
import { axiosApi } from '../../api/setupApi';

const useYearNISData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchYears = async () => {
      try {
  const { data } = await axiosApi.get('/nis/years');
  setData(data); // Make sure response is in expected shape
      } catch (err) {
        setError(err.message || 'Failed to fetch year data');
      } finally {
        setLoading(false);
      }
    };

    fetchYears();
  }, []);

  return { data, loading, error };
};

export default useYearNISData;
